export function getdata() {
	var obj = {
		fpzloptions: [{
			value: '1',
			label: '税控发票'
		}, {
			value: '2',
			label: '数电发票'
		},],
		fplxoptions: [{
			value: '026',
			label: '电子普票'
		}, {
			value: '028',
			label: '电子专票'
		},{
			value: '007',
			label: '纸质普票'
		},{
			value: '004',
			label: '纸质专票'
		},],
		tdywoptions: [{
				value: '01',
				label: '成品油'
			},
			{
				value: '02',
				label: '稀土'
			},
			{
				value: '13',
				label: '机动车'
			},
			{
				value: '03',
				label: '建筑服务'
			},
			{
				value: '06',
				label: '不动产经营租赁服务'
			}
		],
		cezsoptions: [{
				value: '1',
				label: '差额征税-全额开票'
			},
			{
				value: '0',
				label: '差额征税-差额开票'
			}
		],
		jazsoptions: [{
				value: '0',
				label: '销售自己使用过的固定资产'
			},
			{
				value: '1',
				label: '销售收购的二手车'
			},
			{
				value: '2',
				label: '住房租赁'
			},
		],

		searchlist: [{
				prop: "danjh",
				label: '单据号',
				type: "input"
			},
			{
				prop: "danjzt",
				label: '单据状态',
				type: "select",
				selectval: [{
						value: '-1',
						label: '草稿'
					}, {
						value: '0',
						label: '待审核'
					}, {
						value: '1',
						label: '已审核'
					},
					{
						value: '3',
						label: '开票中'
					}
				]
			},
			{
				prop: "tedywlx",
				label: '特殊业务',
				type: "select",
				selectval: [{
						label: "成品油",
						value: "01"
					},
					{
						label: "稀土",
						value: "02"
					},
					{
						label: "建筑服务",
						value: "03"
					},
					{
						label: "不动产经营租赁",
						value: "06"
					},
					{
						label: "机动车",
						value: "13"
					},
				]
			},
			{
				prop: "danjly",
				label: '单据来源',
				type: "select",
				selectval: [{
						value: '1',
						label: '文件导入'
					},
					{
						value: '2',
						label: '手工录入'
					},
					{
						value: '3',
						label: '客户接口'
					},
					{
						value: '6',
						label: '扫码开票'
					},
					{
						value: '7',
						label: '红冲重开'
					},
					{
						value: '8',
						label: '作废重开'
					},
				]
			},
			{
				prop: "danjrq",
				label: '单据日期',
				type: "date",
				valueformat: "yyyyMMdd"
			},
			{
				prop: "customerNo",
				label: '客户编号',
				type: "input"
			},
			{
				prop: "jiashj",
				label: '价税合计',
				type: "input",
				isNumber: true
			},
			{
				prop: "zhidr",
				label: '制单人',
				type: "input"
			}, {
				prop: "shangpmc",
				label: '商品名称',
				type: "input"
			}, {
				prop: "zidysm",
				label: '自定义说明',
				type: "input"
			}, {
				prop: "goufmc",
				label: '购方名称',
				type: "input"
			}, {
				prop: "hejje",
				label: '金额',
				type: "input",
				isNumber: true
			}, {
				prop: "hejse",
				label: '税额',
				type: "input",
				isNumber: true
			},
		],
		searchdata: {
			"danjh": "",
			"danjzt": "",
			"danjly": "",
			"tedywlx": "",
			"customerNo": "",
			"jiashj": "",
			"zhidr": "",
			"shangpmc": "",
			"hejse": "",
			"hejje": "",
			"goufmc": "",
			"zidysm": "",
			"danjrq": [],
			"faplxdm": ""
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		headData: [{
				title: "单据号",
				prop: "danjh",
				width: "250",
				issort: true
			},
			{
				title: "单据状态",
				prop: "fapzt",
				width: "110",
				custom: true,
				issort: true
			},
			{
				title: "发票来源",
				prop: "faply",
				width: "110",
				custom: true,
				issort: true
			},
			{
				title: "发票类型",
				prop: "faplxdm",
				width: "110",
				custom: true,
				issort: true
			},
			{
				title: "特殊业务",
				prop: "tedywlx",
				width: "100",
				custom: true,
				issort: true
			},
			{
				title: "购方名称",
				prop: "goufmc",
				width: "160",
				align: "left",
				issort: true
			},
			{
				title: "金额",
				prop: "hejje",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			},
			{
				title: "税额",
				prop: "hejse",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			},
			{
				title: "商品名称",
				prop: "shangpmc",
				width: "110",
				issort: false
			},
			{
				title: "价税合计",
				prop: "jiashj",
				width: "110",
				align: "right",
				AmountFormat: true,
				issort: true
			},
			{
				title: "单据日期",
				prop: "danjrq",
				width: "120",
			},
			{
				title: "制单人",
				prop: "zhidr",
				width: "110",
				issort: true
			},
			{
				title: "申请人",
				prop: "shenqr",
				width: "110",
				issort: true
			},
			{
				title: "自定义说明",
				prop: "zidysm",
				width: "160",
				align: "left"
			},
			{
				title: "自定义说明二",
				prop: "zidysm2",
				width: "160",
				align: "left"
			},
			{
				title: "创建日期",
				prop: "chuangjrq",
				width: "190",
				align: "left",
			}, {
				title: "操作",
				prop: "cz",
				width: "100",
				custom: true,
				fixed: "right",
				align: "center",
			},
		]
	}
	return obj
}
